import * as React from 'react';
import Loading from 'shared/Loading';
import ListItem from './ListItem';
import articlesReducer, {
  fetchArticles,
  getArticles,
  initialState,
  isFetchComplete,
} from 'redux/articles';
import fetchData from 'redux/fetchData';
import BlogHeader from './BlogHeader';

function Articles() {
  const [state, dispatch] = React.useReducer(articlesReducer, initialState);
  const [filter, setFilter] = React.useState('');

  React.useEffect(() => {
    fetchData(dispatch, fetchArticles);
  }, []);

  const articles = getArticles(state).filter((article) => new RegExp(filter, 'i').test(article.title));

  return (
    <section className="article-list blog">
      <BlogHeader onFilter={setFilter} />
      {!isFetchComplete(state) && <Loading />}
      {articles.map((article) => <ListItem key={article.title} article={article} />)}
    </section>
  );
}

export default Articles;
